import { View } from "./View";

export const Select = (props: any) => {
  return <View {...props} />;
};
